import { Select } from '@metaicg/sensei-ui';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { t, i18n: i18nInstance } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18nInstance.changeLanguage(lang);
  };

  const languageOptions = [
    { label: `🇬🇧 ${t('common:components.language.en')}`, value: 'en' },
    { label: `🇪🇸 ${t('common:components.language.es')}`, value: 'es' },
    { label: `🇵🇹 ${t('common:components.language.pt')}`, value: 'pt' },
  ];

  const currentLanguage = i18nInstance.language?.split('-')[0] || 'en';

  return (
    <Select
      placeholder="Select language"
      onChange={(lang: any) => handleLanguageChange(lang as string)}
      value={currentLanguage}
      options={languageOptions}
    />
  );
};

export default LanguageSelector;
